import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/store/modules/auth'
import car from '@/store/modules/car'
import carHistory from '@/store/modules/carHistory'
import carMark from '@/store/modules/carMark'
import carModel from '@/store/modules/carModel'
import city from '@/store/modules/city'
import location from '@/store/modules/location'
import notification from '@/store/modules/notification'
import order from '@/store/modules/order'
import promotion from '@/store/modules/promotion'
import repair from '@/store/modules/repair'
import repairType from '@/store/modules/repairType'
import softwareUpdate from '@/store/modules/softwareUpdate'
import station from '@/store/modules/station'
import ui from '@/store/modules/ui'
import client from '@/store/modules/client'
import feedback from '@/store/modules/feedback'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {
        clear({ commit }) {
            // TODO: Очистка Store

            commit('client/setClient', undefined)
        },
    },
    modules: {
        auth,
        car,
        carHistory,
        carMark,
        carModel,
        city,
        location,
        notification,
        order,
        promotion,
        repair,
        repairType,
        softwareUpdate,
        station,
        ui,
        client,
        feedback,
    },
})
